import React, { useEffect, useState } from 'react'
import AddCategory from './add_category';
import { useAuth } from '../../providers/auth_provider';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import EditCategory from './edit_category';
import CategoryStatusDropdown from './modals/category_active_inactive_modal';
import DeleteConfirmation from './modals/confirmation';

const Category = () => {
    const { token } = useAuth();
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({});
    const [categoryId, setCategoryId] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [searchName, setSearchName] = useState('');

    useEffect(() => {
        fetchCategories(currentPage)
    }, [currentPage, limit, searchName]);

    const fetchCategories = async (page) => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/category/get/categories?page=${page}&limit=${limit}&name=${searchName}`, {
                headers: {
                    Signature: `${process.env.REACT_APP_API_SIGNATURE}`,
                    Authorization: `Bearer ${token}`
                }
            });
            setCategories(response.data.categories)
            setPagination(response.data.pagination)
        } catch (error) {
            console.error('Error fetching users:', error)
        }
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
    }

    const displayKeywords = (keywords) => {
        if (!keywords) return '-';
        const keywordsArray = keywords.split(',').map(k => k.trim());
        if (keywordsArray.length <= 3) {
            return keywordsArray.join(', ');
        }
        return keywordsArray.slice(0, 3).join(', ') + '...';
    }

    return (
        <>
            <Helmet>
                <title>Manage Categories - Enervybe</title>
            </Helmet>
            {/* Users List Table */}
            <div className="card">
                <div className="card-header align-items-center border-bottom">
                    <div className="d-flex justify-content-between">
                        <h5 className="card-title">Categories List</h5>
                        <button className="btn btn-sm btn-label-primary waves-effect waves-light" data-bs-toggle="offcanvas" data-bs-target="#offcanvasAddCategory"> <i className='ri-add-line d-none d-sm-inline-block me-2'></i> <i className="ri-add-line me-0 me-sm-1 d-inline-block d-sm-none" /> <span className="d-none d-sm-inline-block">
                            Add Category
                        </span></button>
                    </div>
                </div>

                <div className="card-datatable text-nowrap">
                    <div id="DataTables_Table_0_wrapper"
                        className="dataTables_wrapper dt-bootstrap5 no-footer">
                        <div className="d-flex justify-content-between px-5">
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <input
                                    type="search"
                                    className="form-control form-control-sm"
                                    placeholder="Search Category"
                                    aria-controls="DataTables_Table_0"
                                    value={searchName}
                                    onChange={(e) => setSearchName(e.target.value)}
                                />
                            </div>
                            <div className="dataTables_length" id="DataTables_Table_0_length">
                                <select
                                    name="DataTables_Table_0_length"
                                    aria-controls="DataTables_Table_0"
                                    className="form-select form-select-sm"
                                    value={limit}
                                    onChange={(e) => setLimit(e.target.value)}>
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table
                                className="datatables-ajax table table-bordered dataTable no-footer"
                                id="DataTables_Table_0"
                                aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Categories</th>
                                        <th>Icon</th>
                                        <th>Description</th>
                                        <th>Keywords</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories?.map((category, index) => (
                                        <tr className="odd" key={category.id}>
                                            <td>{index + 1}</td>
                                            <td>{category.name}</td>
                                            <td>
                                                <img src={category.image} width={30} height={30} alt={category.title} className='rounded-pill' />
                                            </td>
                                            <td style={{ whiteSpace: "pre-line" }}>
                                                {category.description}
                                            </td>
                                            <td>
                                                {displayKeywords(category.keywords)}
                                            </td>
                                            <td>
                                                <CategoryStatusDropdown category={category} fetchCategories={fetchCategories} />
                                            </td>
                                            <td style={{ width: "200px" }}>
                                                <div className='gap-2 d-flex'>
                                                    <button onClick={() => setCategoryId(category.id)} className="btn text-primary" data-bs-toggle="offcanvas" data-bs-target="#offcanvasEditCategory">
                                                        <span className="d-none d-sm-inline-block">
                                                            Edit
                                                        </span>
                                                    </button>
                                                    <DeleteConfirmation category={category} fetchCategories={fetchCategories} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <nav aria-label="Page navigation">
                    <ul className="pagination pagination-sm pt-2">
                        <li className={`page-item prev ${pagination.currentPage === 1 ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(pagination.currentPage - 1)}>
                                <i className="tf-icon ri-skip-back-mini-line ri-20px" />
                            </a>
                        </li>
                        {Array.from({ length: pagination.totalPages }, (_, index) => index + 1).map(page => (
                            <li key={page} className={`page-item ${pagination.currentPage === page ? 'active' : ''}`}>
                                <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(page)}>
                                    {page}
                                </a>
                            </li>
                        ))}
                        <li className={`page-item next ${pagination.currentPage === pagination.totalPages ? 'disabled' : ''}`}>
                            <a className="page-link waves-effect" href="#" onClick={() => handlePageChange(pagination.currentPage + 1)}>
                                <i className="tf-icon ri-skip-forward-mini-line ri-20px" />
                            </a>
                        </li>
                    </ul>
                </nav>

                {/* Offcanvas to add new user */}
                <EditCategory categoryId={categoryId} fetchCategories={fetchCategories} />
                <AddCategory fetchCategories={fetchCategories} />
            </div>
        </>
    )
}

export default Category;